<template>
    <div class="app">
        <form class="login-form" action="" v-on:submit="modifyPhone">
            <div class="big-tips">
                手机验证码发送至当前手机号:<br/><label class="f-strongest">{{mobileNo | dotted}}</label>
            </div>
            <verify-code v-model="verifyCode" namespace="ModifyPhone" url="/app/user/send" :param="param"></verify-code>
            <div style="padding: 0.75rem 0.5rem;">
                <button class="btn-ok phone-click-next" type="submit" >下一步</button>
            </div>
        </form>
    </div>
</template>
<script>
    import VerifyCode from '../../components/VerifyCode'
    const check = function(loginForm) {
        if (!loginForm.verifyCode) {
            return '请输入验证码'
        }
    };

    module.exports = {
        data: function() {
            return {
                verifyCode: '',
                backendUrl: localStorage.backendUrl,
                mobileNo: localStorage.mobileNo,
                param: {
                    //1：注册/登录  2：修改密码  3：修改手机号
                    operateType:'3'
                }
            }
        },
        components: {
            VerifyCode
        },
        methods: {
            modifyPhone: function($event) {
                $event.preventDefault();
                var msg = check(this);
                if (msg) {
                    return this.$utils.alert(msg);
                }
                this.$http.post('/app/user/verify', {
                    verifyCode:this.verifyCode
                }).then(res => {
                    var data = res.body;
                    if (data.resultCode === this.constant.RESULT_SUCCESS) {
                        this.$router.push('confirmPhone')
                    } else {
                        this.$utils.alert(data.resultMsg)
                    }
                })
                return false;
            }
        }
    }
</script>
<style>
    .moblieNo{
        line-height: 40px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// ModifyPhone.vue?4c454fca